<template>
  <div style="text-align: right">
    <span>
      <a @click="managePage(-1)"><i class="el-icon-d-arrow-left"/> prev </a> <input id="pager" v-model.number="page" type="number" style="width: 5em"> | {{ numPages }} <a @click="managePage(1)">next <i class="el-icon-d-arrow-right"/></a>
    </span>
    <div class="file-view" style="width: 100vh; text-align: center;">
      <span>
        <div v-if="loadedRatio > 0 && loadedRatio < 1" :style="{ width: loadedRatio * 100 + '%' }" style="background-color: green; color: white; text-align: center; " >{{ Math.floor(loadedRatio * 100) }}%</div>
        <pdf
          v-loading="fileloading"
          ref="pdf"
          :src="tempfile"
          :page="page"
          :rotate="rotate"
          type="application/pdf"
          class="file-iframe"
          @progress="loadedRatio = $event"
          @num-pages="numPages = $event"
          @link-clicked="page = $event"/>
      </span>
    </div>
  </div>

</template>

<script>
import pdf from 'vue-pdf'

export default {
  name: 'FileView',
  components: { pdf },
  props: {
    file_object: {
      type: Object,
      require: true,
      default: null
    },
    file: {
      type: String,
      require: true,
      default: null
    }
  },
  data: function() {
    return {
      fileloading: true,
      filename: '',
      currentPage: 0,
      pageCount: 0,
      page: 1,
      loadedRatio: 0,
      numPages: 0,
      rotate: 0,
      tempfile: ''
    }
  },
  watch: {
    // page: function(item) {
    //   if (this.page >= this.numPages) {
    //     this.page = this.numPages - 1
    //     return this.numPages
    //   } else if (this.page <= 0) {
    //     this.page = 1
    //     return 1
    //   }
    // },
    loadedRatio: function(item) {
      if (item > 0 && item < 0) {
        this.fileloading = true
      } else {
        this.fileloading = false
      }
    }
  },
  created() {
    this.tempfile = this.$store.getters.base_url + '/qms/file?file=temp_qms_files/' + this.file
  },
  methods: {
    managePage(num) {
      this.page = this.page + num
      if (this.page > this.numPages) {
        this.page = this.numPages
      } else if (this.page <= 0) {
        this.page = 1
      }
    }
  }
}
</script>

<style lang="scss">
  .file-view {
    .file-iframe {
      position:relative;
      top:50%;
      left:50%;
      transform:translate(-37%, 5%);
      canvas {
        border: 1px solid;
        margin-bottom: 5vh;
      }
    }

  }
</style>
